import React from "react";
import * as styles from "./fullWidthText.module.scss"

const FullWidthText = ({ data }) => {

    return (
        <div 
            className={`${styles.fullWidthText}`}
        >
            <div className={`container`}>
                <div className="row">
                    <div 
                        className={`
                            col-lg-${data.columnWidth} 
                            offset-lg-${data.columnOffset} 
                            ${data.borderBottom && styles.fullWidthText__border}
                            ${styles.fullWidthText__cols}
                        `}
                        style={{
                            paddingTop: `${data.paddingTop}rem`,
                            paddingBottom: `${data.paddingBottom}rem`
                        }}
                    >
                        {data.content &&
                            <div className={styles.fullWidthText__content} dangerouslySetInnerHTML={{ __html: data.content }}/>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FullWidthText